import React, { useState } from 'react';
import ResetPasswordParams from '../types/ResetPasswordParams';
import resetPassword from '../api/resetPassword';

import Header from '@/features/facility/welcome/components/Header';
import Footer from '@/features/facility/welcome/components/Footer';
import NotFound from '@/template/NotFound';

const Reset: React.FC = () => {
  const [password, setPassword] = useState<string>("")
  const [passwordConfirmation, setPasswordConfirmation] = useState<string>("")
  const [alertMessageOpen, setAlertMessageOpen] = useState<boolean>(false)
  const [alertMessages, setAlertMessages] = useState<string[]>([])
  const [isSubmitted, setSubmitted] = useState<boolean>(false)
  const [isNotFound, setNotFound] = useState<boolean>(false)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const params: ResetPasswordParams = {
      password: password,
      password_confirmation: passwordConfirmation
    }

    try {
      await resetPassword(params);
      setAlertMessageOpen(false);
      setSubmitted(true);
    } catch (err: any) {
      setAlertMessageOpen(true);
      setSubmitted(false);
      // statusが404の場合
      if (err.response && err.response.status === 404) {
        return setNotFound(true);
      }
      // err.responseが存在し、かつerr.response.dataが存在する場合
      if (err.response && err.response.data && err.response.data.errors) {
        setAlertMessageOpen(true);
        setAlertMessages(err.response.data.errors);
      } else {
        // 予期せぬエラーの場合の処理
        setAlertMessageOpen(false);
        console.log('An unexpected error occurred:', err);
      }
    }
  }

  const messages = alertMessages.length === 0 ? '' : alertMessages.map((message: string) =>
    <li>{message}</li>
  );

  const form = (
    <div className="inner">
      <h1 className="c-ttl__01">パスワード再設定</h1>
      { alertMessageOpen &&
        <div className="contact-note" style={{marginTop: '20px', marginBottom: '0px'}}>
          <ul>
            { messages }
          </ul>
        </div>
      }
      <div className="contact-box">
        <div className="contact-box__left">
          <div className="mbpc-98 mbsp-32">
            <form onSubmit={handleSubmit}>
              <div className="contact-box__form js-item" id="id-01">
                <div className="contact-box__item">
                  <label className="contact-box__ttl"><span>新しいパスワード</span><small>必須</small></label>
                  <div className="contact-box__ct">
                    <input name="password" type="password" className="input" onChange={ event => setPassword(event.target.value) } />
                  </div>
                </div>
                <div className="contact-box__item">
                  <label className="contact-box__ttl"><span>新しいパスワード(確認)</span><small>必須</small></label>
                  <div className="contact-box__ct">
                    <input name="password_confirmation" type="password" className="input" onChange={ event => setPasswordConfirmation(event.target.value) } />
                  </div>
                </div>
                <p className="c-ttl__02"><span>※パスワードは半角数字、半角記号、半角英大文字、半角英小文字から3種類以上を含む8文字以上で入力してください。</span></p>
              </div>
              <button type="submit" className="c-btn__01">変更する</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

  const completed = (
    <div className="inner">
      <h1 className="c-ttl__01">パスワード再設定完了</h1>
      <div className="sec-link" style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0', paddingRight: '0' }}>
        <p className="c-txt__01 c-al--c"><span>パスワードの再設定が完了しました。</span></p>
        <a href="/facility/welcome" className="c-btn__01 c-btn__01--white">TOPページに戻る</a>
      </div>
    </div>
  );

  if (isNotFound) {
    return <NotFound />;
  }

  return (
    <React.Fragment>
      <Header />
      <main className="wrapper">
        <section className="sec-posts">
          { isSubmitted ? completed : form }
        </section>
      </main>
      <Footer />
    </React.Fragment>
  );
}

export default Reset;
